import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import { ReportListPage } from '@features/client/reports';

export const Route = createFileRoute('/c/$orgId/$portalId/reports/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <ReportListPage />
    </UserLayout>
  );
}
